export default function AccordionBody(props) {
    return (
        <div className="accordion mb-4">
            {props.children}
        </div>
    )
}